
import {
    getFirestore,
    collection,
    doc,
    query,
    where,
    orderBy,
    startAfter,
    limit,
    getDoc,
    getDocs,
    updateDoc,
    setDoc,
    addDoc,
} from "firebase/firestore";

import { db, getDefaultFirestore } from "../apis/auth";

const usersCollection = "users";
// const dimScheduleDoc = "curr_sch";


export async function getUser(email) {
    console.log(`===> ${usersCollection}-Query : getUser(${email})`);
    let result = null;
    let db = await getDefaultFirestore().catch((error) => {
        return Promise.reject(error);
    });
    const collectionRef = collection(db, usersCollection);

    const q = query(collectionRef, where("user_email", "==", email), limit(1));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(doc => {
        console.log("users docs : ", doc.data());
        result = doc.data();
    });

    if (result != null) {
        return Promise.resolve(result);
    }
    return Promise.reject("Unable to get user");
}

export function getAllUser() {
    return new Promise(async (resolve, reject) => {
        let db = await getDefaultFirestore().catch((error) => {
            return Promise.reject(error);
        });
        let queryObj = query(
            collection(db, usersCollection),
        );
        getDocs(queryObj)
            .then(querySnapshot => {
                const devices = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                resolve(devices);
            })
            .catch(error => {
                console.error(`Unable to fetching users}`);
                reject(error);
            });
    });
}

export function getAllDisplayNames() {
    return new Promise(async (resolve, reject) => {
        try {
            const db = await getDefaultFirestore();

            const queryObj = query(collection(db, "db_settings"));

            const querySnapshot = await getDocs(queryObj);

            const displayNames = querySnapshot.docs
                .map(doc => doc.data()?.dbName?.toLowerCase())
                .filter(name => !!name);

            resolve(displayNames);
        } catch (error) {
            console.error("Error fetching display names:", error);
            reject(error);
        }
    });
}

export async function addUser(userData) {
    try {
        let db = await getDefaultFirestore();
        const usersCollection = collection(db, 'users');
        const emailQuery = query(usersCollection, where('user_email', '==', userData.user_email));
        const querySnapshot = await getDocs(emailQuery);
        if (!querySnapshot.empty) {
            return Promise.reject('Email already exists in the database');
        }
        const docSnap = await addDoc(usersCollection, userData);
        return Promise.resolve(docSnap.id);
    } catch (error) {
        return Promise.reject(error);
    }
}


export function updateUser(docId, updateData) {
    return new Promise(async (resolve, reject) => {
        try {
            const db = await getDefaultFirestore();
            const userRef = doc(db, 'users', docId);
            await updateDoc(userRef, updateData);
            resolve('User updated successfully');
        } catch (error) {
            console.error(`Error updating user: ${error}`);
            reject(error);
        }
    });
}

export async function addPermissionConfig(updateData) {
    try {
        const db = await getDefaultFirestore();
        const docRef = doc(db, 'app_cfg', 'permission_config');
        const docSnap = await getDoc(docRef);

        // Log the updateData to ensure it's correct
        console.log("updateData: ", updateData);

        // Check if document exists
        if (!docSnap.exists()) {
            // If document doesn't exist, create a new one
            await setDoc(docRef, updateData);
            return 'Document created with new permission data';
        }

        const currentData = docSnap.data();

        // Check if the 'type' exists in the current data
        if (currentData[updateData.type]) {
            // Update the specific array (add or modify item)
            const updatedData = currentData[updateData.type].map(item => {
                // If the 'key' matches, update that item
                if (item.key === updateData.key) {
                    return { ...item, ...updateData[updateData.type][0] }; // Merge the updated data
                }
                return item;
            });

            if (!updatedData.some(item => item.key === updateData.key)) {
                updatedData.push(updateData[updateData.type][0]);
            }

            if (!updatedData || updatedData.some(item => !item.key || !item.description || !item.group)) {
                throw new Error("Invalid data in update, missing required fields.");
            }

            // Log the updated data
            console.log("Updated Data: ", updatedData);

            // Update the specific type field in the document
            const updatePayload = { [updateData.type]: updatedData };
            // Ensure the updatePayload doesn't contain undefined values
            if (Object.values(updatePayload).some(value => value === undefined)) {
                throw new Error("Update payload contains undefined values.");
            }

            await updateDoc(docRef, updatePayload);
            return `Document updated with new ${updateData.type} data`;
        } else {
            // If the type doesn't exist, add it
            const updatePayload = { [updateData.type]: updateData[updateData.type] };

            // Ensure the updatePayload doesn't contain undefined values
            if (Object.values(updatePayload).some(value => value === undefined)) {
                throw new Error("Update payload contains undefined values.");
            }

            await updateDoc(docRef, updatePayload);
            return `Document updated with new ${updateData.type} data (new type created)`;
        }
    } catch (error) {
        console.error('Error updating document:', error);
        throw error;
    }
}

export async function updatePermissionConfig(updateData, key) {
    try {
        const db = await getDefaultFirestore();
        const docRef = doc(db, 'app_cfg', 'permission_config');
        const docSnap = await getDoc(docRef);

        console.log("updateData: ", updateData);

        // Check if document exists
        if (!docSnap.exists()) {
            // If document doesn't exist, create a new one with the provided data
            await setDoc(docRef, { [updateData.type]: [updateData[updateData.type][0]] });
            return 'Document created with new permission data';
        }

        const currentData = docSnap.data();
        const typeData = currentData[updateData.type] || []; // Fallback to an empty array if type doesn't exist

        // Check if the 'key' already exists in the specified type data
        const keyIndex = typeData.findIndex(item => item.key === key);

        if (keyIndex > -1) {
            // If the key exists, update the existing object
            typeData[keyIndex] = { ...typeData[keyIndex], ...updateData[updateData.type][0] }; // Merge the new data with the existing one
        } else {
            // If the key doesn't exist, add the new object
            typeData.push(updateData[updateData.type][0]);
        }

        // Prepare the payload to update the document
        const updatePayload = { [updateData.type]: typeData };
        // Update the Firestore document
        await updateDoc(docRef, updatePayload);

        return `Document updated with updated ${updateData.type} data`;
    } catch (error) {
        console.error('Error updating document:', error);
        throw error;
    }
}


export function getAllPermissionConfig() {
    return new Promise(async (resolve, reject) => {
        let db = await getDefaultFirestore().catch((error) => {
            return Promise.reject(error);
        });
        const docRef = doc(db, 'app_cfg', 'permission_config');
        getDoc(docRef)
            .then(docSnapshot => {
                if (docSnapshot.exists()) {
                    resolve(docSnapshot.data() || []);
                } else {
                    reject('Document does not exist');
                }
            })
            .catch(error => {
                console.error('Unable to fetch document:', error);
                reject(error);
            });
    });
}
export function getAllProject() {
    return new Promise(async (resolve, reject) => {
      try {
        const docRef = doc(db(), 'settings', 'project');
        const docSnapshot = await getDoc(docRef);
        
        if (docSnapshot.exists()) {
          resolve(docSnapshot.data() || []);
        } else {
          // Initialize the document with empty projects array
          const initialData = { projects: [] };
          await setDoc(docRef, initialData);
          resolve(initialData);
        }
      } catch (error) {
        console.error('Unable to fetch document:', error);
        reject(error);
      }
    });
  }

// export function updatePermissionConfig(data) {
//     return new Promise(async (resolve, reject) => {
//         let db = await getDefaultFirestore().catch((error) => {
//             return Promise.reject(error);
//         });
//         const docRef = doc(db, 'app_cfg', 'permission_config');
//         updateDoc(docRef, data)
//             .then(() => {
//                 resolve('Document updated successfully');
//             })
//             .catch(error => {
//                 console.error('Error updating document:', error);
//                 reject(error);
//             });
//     });
// }



// export async function updateDimSchedule(dimScheduleData) {
//     console.log(`===> ${dimScheduleCollection}-Query : getDimSchedule()`);
//     const docRef = doc(db(), dimScheduleCollection, dimScheduleDoc);
//     await updateDoc(docRef, dimScheduleData);
//     // if (docSnap.exists()) {
//         return Promise.resolve();
//     // }
//     // return Promise.reject("Unable to update dim schedule");
// }